export default __webpack_public_path__ + "static/media/welpentreffen_31.be944881.jpg";